export const EXPERIMENTAL_LOCATIONS = ['Воронеж', 'Самара'];
